"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addAnnualCommonWidgets = void 0;
var GdprBanner_1 = require("./GdprBanner");
var FalconNavigatorHeaderWidget_1 = require("./FalconNavigatorHeaderWidget");
var NotificationModalWidget_1 = require("./NotificationModalWidget");
var UniqueSellingPointWidget_1 = require("./UniqueSellingPointWidget");
var addAnnualCommonWidgets = function (extensions) {
    extensions.journeyComponents.addQuestionComponent({
        id: "gdprBanner",
        component: GdprBanner_1.GdprBanner
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "falconNavigatorHeader",
        component: FalconNavigatorHeaderWidget_1.FalconNavigatorHeaderWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "notificationModal",
        component: NotificationModalWidget_1.NotificationModalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "uniqueSellingPointWidget",
        component: UniqueSellingPointWidget_1.UniqueSellingPointWidget
    });
};
exports.addAnnualCommonWidgets = addAnnualCommonWidgets;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/common/index.js
// module id = 3719
// module chunks = 0